/**
 * Comprime una imagen client-side antes de subirla.
 * - Redimensiona a max 1600px de ancho
 * - JPEG quality 0.85
 * - Mantiene EXIF orientation correcta
 *
 * Reduce 5-10MB de foto de camara a ~500KB-1MB sin perder OCR readability.
 */
export async function compressImage(file: File, maxWidth = 1600, quality = 0.85): Promise<File> {
  if (!file.type.startsWith("image/")) return file;
  // Si ya es chico (<1MB) no comprimir
  if (file.size < 1024 * 1024) return file;

  try {
    const bitmap = await createImageBitmap(file);
    const scale = bitmap.width > maxWidth ? maxWidth / bitmap.width : 1;
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, w, h);

    const blob: Blob | null = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", quality)
    );
    if (!blob) return file;

    const newName = file.name.replace(/\.[^.]+$/, ".jpg");
    return new File([blob], newName, { type: "image/jpeg" });
  } catch {
    return file;
  }
}
